export const historyStore = {
  state: {
    inventoryRecordsHistory: []
  },
  getters: {
    getInventoryRecordsHistory(state) {
      return state.inventoryRecordsHistory;
    }
  },
  mutations: {
    addInventoryRecordHistory(state, value) {
      const d = {
        ...value,
        updated: null
      };
      state.inventoryRecordsHistory.push(d);
    }
  },
  actions: {
    addInventoryRecordHistory(context, value) {
      context.commit("addInventoryRecordHistory", value);
    }
  }
};
